import { RicosPluginToolbarNames } from 'ricos-types';
import { getAddButtons } from './getAddButtons.js';
import { getToolbarButtons } from './getToolbarButtons.js';
import { InsertModal } from './modals/InsertModal.js';
import { AudioSettingsModal } from './modals/SettingsModal.js';
import { tiptapExtensions } from './tiptap/tiptap.js';
import { AUDIO_TYPE } from 'ricos-content';
import './types.js';
import 'lodash';
import 'wix-rich-content-editor-common';
import 'wix-rich-content-ui-components';
import './consts.js';
import './defaults.js';
import 'ricos-schema';
import './icons/InsertPluginIcon.js';
import 'react';
import '@wix/design-system';
import 'ricos-context';
import 'wix-rich-content-common';
import './style-inject.es-e7b07dd7.js';
import './dataHooks.js';
import './modals/audio-embed.js';
import 'wix-react-player';
import './modals/utils.js';
import './modals/audio-upload.js';
import 'wix-rich-content-plugin-commons';
import './toolbar/audioPluginService.js';
import 'wix-rich-content-toolbars-ui';
import './toolbar/AudioEditButton.js';
import 'wix-rich-content-common/libs/imageUtils';
import 'ricos-schema/dist/statics/audio.defaults.json';
import './tiptap/component.js';
import './viewer/audio-viewer.js';
import './audio.rtlignore-20182d5f.js';
import './ReactPlayerWrapper.js';
import 'classnames';
import './components/AudioImage.js';
import './components/AudioDetails.js';
import './components/AudioActionIcons.js';
import './components/SoundControl.js';
import './components/ContextMenu.js';
import './components/DropdownMenu.js';
import './components/AudioDuration.js';
import './viewer/audio-embed-viewer.js';
import 'wix-rich-content-plugin-html/libs/HtmlComponent';

const pluginAudio = (config = {}) => {
  return {
    config,
    type: AUDIO_TYPE,
    tiptapExtensions,
    toolbar: {
      names: [RicosPluginToolbarNames.AUDIO],
      getButtons: (config2, services) => getToolbarButtons(config2, services)
    },
    getAddButtons: (config2, services) => getAddButtons(config2),
    __exports: {
      InsertModal,
      SettingsModal: AudioSettingsModal
    }
  };
};

export { pluginAudio };
//# sourceMappingURL=editor.js.map
